/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { GridApi, IRowNode } from "ag-grid-community";
import { DataTableColumnDefinition } from "../store/DataTableProvider.types";
import { RoiFrame } from "@inscopix/ideas-hyperformula";
import { CellValueRendererBase } from "../cell-value-renderers/CellValueRendererBase";
import { useState } from "react";
import { DataTableRowData } from "../layout/DataTable";
import { CellEditorRoiFrame } from "../cell-editors/CellEditorRoiFrame";

const styles = {
  root: css`
    width: 100%;
  `,
  value: css`
    min-width: 0;
    overflow: hidden;
    display: inline;
  `,
};

interface CellRendererRoiFrameProps {
  api: GridApi;
  value: RoiFrame;
  isCustomFormula: boolean;
  rowId: string;
  rowNode: IRowNode<DataTableRowData>;
  columnId: string;
  columnName: string;
  columnDefinition: Extract<DataTableColumnDefinition, { kind: "roi_frame" }>;
  isCellEditable: boolean;
  tableId: string;
}

/** Cell renderer that renders cells in ROI frame columns */
export const CellRendererRoiFrame = ({
  api,
  value,
  rowId,
  rowNode,
  columnId,
  columnName,
  columnDefinition,
  isCellEditable,
  isCustomFormula,
  tableId,
}: CellRendererRoiFrameProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      {isModalOpen && (
        <CellEditorRoiFrame
          isReadOnly
          gridApi={api}
          value={value}
          rowId={rowId}
          columnName={columnName}
          columnDefinition={columnDefinition}
          onChangeFormula={() => undefined}
          stopEditing={() => setIsModalOpen(false)}
          tableId={tableId}
        />
      )}
      <EuiFlexGroup
        css={styles.root}
        gutterSize="s"
        alignItems="flexEnd"
        justifyContent="spaceBetween"
      >
        <EuiFlexItem css={styles.value} grow={false}>
          <CellValueRendererBase
            value={value}
            isDefaultValue={!isCustomFormula}
          />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButtonIcon
            aria-label="Inspect cell statuses"
            iconType="inspect"
            onClick={() => {
              if (isCellEditable && rowNode.rowIndex !== null) {
                api.startEditingCell({
                  rowIndex: rowNode.rowIndex,
                  colKey: columnId,
                });
              } else {
                setIsModalOpen(true);
              }
            }}
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  );
};
